const DEFAULT_LOCALE = 'de-CH';
const DEFAULT_CURRENCY = 'CHF';
const FRACTION_DIGITS = 2;

const formatAmount = (amount) => Number(amount).toLocaleString(DEFAULT_LOCALE, {
	minimumFractionDigits: FRACTION_DIGITS,
	maximumFractionDigits: FRACTION_DIGITS
});

const formatCardinal = (cardinal) => Number(cardinal).toLocaleString(DEFAULT_LOCALE, {
	minimumFractionDigits: 0,
	maximumFractionDigits: 0
});

const formatCurrency = (amount, currency) => Number(amount).toLocaleString(DEFAULT_LOCALE, {
	style: 'currency',
	currency: currency != null ? currency : DEFAULT_CURRENCY,
	currencyDisplay: 'symbol',
	minimumFractionDigits: FRACTION_DIGITS,
	maximumFractionDigits: FRACTION_DIGITS
});

const formatDate = (date) => (date != null && date instanceof Date) ? date.toLocaleDateString(DEFAULT_LOCALE, {
	dateStyle: 'medium'
}) : date;

const formatDateISO = (date) => (date != null && date instanceof Date) ? date.toISOString().substring(0, 10) : date;

const formatPercent = (amount) => isNaN(amount) ? '–' : (amount > 0 ? '+' : '') + Number(amount).toLocaleString(DEFAULT_LOCALE, {
	style: 'percent',
	minimumFractionDigits: FRACTION_DIGITS,
	maximumFractionDigits: FRACTION_DIGITS
});

export {
	formatAmount,
	formatCardinal,
	formatCurrency,
	formatDate,
	formatDateISO,
	formatPercent
};
